// @ts-nocheck
import { getFormById } from "@store/Framework/Store/Foundation/Components/Form/FormSelector";
import { DestroyFormHandlerParameter } from "@store/Framework/Store/Foundation/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = DestroyFormHandlerParameter;

type HandlerType = Handler<Parameter>;

export const DispatchInput: HandlerType = props => {
    const formExist = getFormById(props.getState(), props.parameter.formId);

    if (formExist) {
        props.dispatch({
            type: "Foundation/Components/Form/DestroyForm",
            parameter: props.parameter,
        });
    }
};

export const chain = [DispatchInput];

const destroyForm = createHandlerChainRunner(chain, "DestroyForm");

export default destroyForm;
